"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sequence = function _sequence() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(function (promises, currentPromise) {
    return promises.then(currentPromise);
  }, Promise.resolve());
};

/**
 * Executes a list of promises and waits before previous promise was resolved.
 * Usefull if you want functions to be executed sequentially and hate async await loops.
 * In difference to queue, sequence responds a single value (the one from the last function
 * in the chain).
 * @param {array} fns, Array of functions
 * @example
 * import { sequence } from 'promise-frites';
 * const analyticsEvents = ['UserCreated', 'InvitationEmailSent', 'UserRedirectedToApp']
 *  .map((event) => () => { 'send a single event to google analytics' });
 *
 * Promise.resolve()
 *   .then(sequence(...analyticsEvents))
 *   .then((userRedirectedToAppResult) => console.log('All items have been saved.'));
 */
var sequence = exports.sequence = function sequence() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function () {
    return _sequence.apply(undefined, [void 0].concat(fns));
  };
};